import React from 'react';
import contiChapter from '../images/conti.png';

import './ChapterPreview.css';

const ChapterPreview = ({
  chapter,
  onClose
}) => {
  if (!chapter) {
    return null;
  }

  return (
    <div className="chapter-preview-inline">

      <button
        className="chapter-preview-popup-close"
        onClick={onClose}
        aria-label="Inapoi la lectii"
        type="button"
      >
        <span>Inapoi</span>
      </button>

      <div className="line-prevew-chapter" />

      <div className="chapter-preview-popup-header">

        <div className="chapter-preview-popup-icon">
          <img
            src={contiChapter}
            alt="Conti"
            className="chapter-preview-popup-conti"
          />
        </div>

        <div className="chapter-preview-popup-header-text">

          <span className="chapter-preview-popup-module">
            {chapter.module}
          </span>

          <h2>
            {chapter.title}
          </h2>

          {chapter.preview?.description && (
            <p>
              {chapter.preview.description}
            </p>
          )}

        </div>
      </div>

      <div className="chapter-preview-popup-divider" />

      <h3 className="chapter-preview-popup-heading">
        {chapter.preview?.heading || 'Ce vei invata'}
      </h3>

      <div className="chapter-preview-popup-objectives">

        {chapter.preview?.objectives?.map(
          (objective, index) => (
            <div
              className="chapter-preview-popup-objective"
              key={index}
            >
              <div className="chapter-preview-popup-check">
                ✓
              </div>

              <p>
                {objective}
              </p>
            </div>
          )
        )}

      </div>

    </div>
  );
};

export default ChapterPreview;